import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'fixedItem',
    'formSection'
  ]

  connect() {
    const observer = new IntersectionObserver(this.hideByScrollPosition.bind(this));

    //targetを指定
    observer.observe(this.formSectionTarget);
  }

  hideByScrollPosition(entries) {
    entries.forEach((entry) => {
      //targetがrootに交差していたら発動
      if (entry.isIntersecting) {
        this.fixedItemTarget.classList.add(this.hideClass)
      } else {
        this.fixedItemTarget.classList.remove(this.hideClass)
      }
    });
  }

  get hideClass() {
    return this.data.get("hideClass");
  }
}